export default __webpack_public_path__ + "static/media/My_car_website_images-7_5.628a2d86.jpg";